import { Chart } from 'chart.js';

const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const TITLE_STYLES = {
    display: false,
    fontSize: 28,
    fontFamily: "'VELUXGothicLight', helvetica, arial, 'Lucida Grande', sans-serif",
};

const colorOptions = {
    backgroundColor: 'rgba(200, 200, 200, 1)',
    borderColor: 'rgba(200, 200, 200, 1)',
}

export default class {
    constructor({
        id,
        statsYear,
        leadsHandle,
        adSpendHandle,
        reviewsHandle,
        leadsByYear,
        adSpendLastYear,
        reviews: reviewsRatings,
    }) {

        const el = document.getElementById(id);
        const leads = el.querySelector(leadsHandle);
        const adSpend = el.querySelector(adSpendHandle);
        const reviews = el.querySelector(reviewsHandle);

        // Leads data chart
        new Chart(leads.getContext('2d'), { // eslint-disable-line no-new
            type: 'bar',
            data: {
                labels: MONTHS,
                datasets: [
                    {
                        label: 'Phone',
                        data: leadsByYear.map(l => parseInt(l.leads_by_platform.phone, 10)),
                        backgroundColor: colorOptions.backgroundColor,
                        borderColor: colorOptions.borderColor,
                        borderWidth: 1,
                    },
                    {
                        label: 'Email',
                        data: leadsByYear.map(l => parseInt(l.leads_by_platform.email, 10)),
                        backgroundColor: 'rgba(230, 230, 230, 1)',
                        borderColor: 'rgba(230, 230, 230, 1)',
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                legend: {
                    display: true,
                },
                title: {
                    ...TITLE_STYLES,
                    text: `Leads Generated ${statsYear}`,
                    align: 'start',
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                        },
                    }],
                    xAxes: [{
                        stacked: true,
                        fontSize: 16,
                    }],
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });

        let previousMonths = [];
        const today = new Date();
        for (let i = 0; i < 12; i++) {
            const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
            previousMonths.push(date);
        }

        previousMonths.reverse();

        const previousAdSpend = previousMonths.map(date => {
            const foundSpend = adSpendLastYear.find((spendEntry) => {
                let [year, month] = spendEntry.month.split('-')

                let intYear = parseInt(year, 10)
                let intMonth = parseInt(month, 10) - 1

                return date.getMonth() === intMonth &&
                    date.getFullYear() === intYear
            })

            return { date, spend: foundSpend ? foundSpend.spend : 0 }
        });

        new Chart(adSpend.getContext('2d'), { // eslint-disable-line no-new
            type: 'bar',
            data: {
                labels: previousAdSpend.map((m) => m.date.toLocaleString('en-us',{ month:'long' })),
                datasets: [
                    {
                        label: 'Spend',
                        data: previousAdSpend.map((m) => m.spend),
                        ...colorOptions,
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                legend: {
                    display: false,
                },
                title: {
                    ...TITLE_STYLES,
                    text: 'Google Ad Spend Past 12 Months',
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        },
                    }],
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });

        let reviewRatings = [5, 4, 3, 2, 1].map((r) => {
            const ratingCount = reviewsRatings.find(rating => rating['rating'] === r);
            return (ratingCount && ratingCount['count']) || 0;
        });

        new Chart(reviews.getContext('2d'), { // eslint-disable-line no-new
            type: 'horizontalBar',
            data: {
                labels: ['5 Star', '4 Star', '3 Star', '2 Star', '1 Star'],
                datasets: [{
                    label: '',
                    data: reviewRatings,
                    ...colorOptions,
                    borderWidth: 1,
                }],
            },
            options: {
                legend: {
                    display: false,
                },
                title: {
                    ...TITLE_STYLES,
                    text: 'YEXT Ratings - All Time',
                },
                scales: {
                    xAxes: [{
                        fontSize: 16,
                        ticks: {
                            beginAtZero: true,
                        },
                    }],
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });
    }
}
